import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { RateStatusDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-rate-status',
  templateUrl: './rate-status.component.html',
  styleUrls: ['./rate-status.component.scss']
})
export class RateStatusComponent implements OnChanges {

  ratestatusForm: FormGroup;
  ratestatusFormArray: FormGroup;
  control = new FormControl();
  @Input() ratestatuss: RateStatusDto[];
  @Input() routeAnimationsElements: any;
  @Output() ratestatus = new EventEmitter<RateStatusDto[]>();
  @Output() deleteRateStatusEvent = new EventEmitter<any>();

  selectedRateStatus: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createRateStatusForm();
  }

  createRateStatusForm() {
    this.ratestatusForm = this.fb.group({
      RateStatusName: ['', Validators.required],
      id: null,
    });
    this.ratestatusFormArray = this.fb.group({
      RateStatuss: this.fb.array([]),
    });
    this.setRateStatus();
  }

  // method to display ratestatuss
  setRateStatus() {
    const control = this.ratestatusFormArray.controls.RateStatuss as FormArray;
    this.ratestatuss.forEach((e) => {
      control.push(
        this.fb.group({
          RateStatusName: e.RateStatusName,
          id: e.id,
        })
      );
    });
  }

  // method to add RateStatus
  addRateStatus(value: RateStatusDto) {
    const control = this.ratestatusFormArray.controls.RateStatuss as FormArray;
    control.insert(
      0,
      this.fb.group({
        RateStatusName: value.RateStatusName,
        id: null,
      })
    );
  }

  selectRateStatus(value) {}

  // method to delete ratestatus from arrary list
  deleteRateStatus(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.ratestatusFormArray.controls.RateStatuss as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.ratestatuss.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.ratestatuss[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: RateStatusDto) {
    if (this.ratestatusForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.ratestatusFormArray
        .get('RateStatuss')
        ['controls'][this.selectedIndex].patchValue({
          RateStatusName: formValue.RateStatusName,
        });
    } else {
      this.addRateStatus(formValue);
    }
    this.selectedIndex = null;
    this.ratestatusForm.reset();
  }

  onEdit(index, value: RateStatusDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.ratestatusForm.patchValue({ RateStatusName: value.RateStatusName });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.ratestatusForm.reset();
  }

  onSubmit(formValue: RateStatusDto[]) {
    this.ratestatus.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteRateStatusEvent.emit(this.filteredDelete);
    }
  }
}

